import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  NgxGalleryAnimation,
  NgxGalleryImage,
  NgxGalleryImageSize,
  NgxGalleryOptions,
} from "@kolkov/ngx-gallery";
import { forkJoin, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ReaderService } from "../../services/reader.service";

@Component({
    selector: "app-image-gallery",
    templateUrl: "./image-gallery.component.html",
    styleUrls: ["./image-gallery.component.scss"],
    standalone: false
})
export class ImageGalleryComponent implements OnInit, OnDestroy {
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[] = [];
  images: any;
  private objectUrls: string[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) obj: any,
    private readerService: ReaderService
  ) {
    this.images = obj.images;
  }

  ngOnInit(): void {
    this.galleryOptions = [
      {
        imageSize: NgxGalleryImageSize.Contain,
        thumbnailsColumns: this.images.length,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewKeyboardNavigation: true,
      },
    ];

    const requests = (this.images || [])
      .filter((image) => image !== undefined && image !== "undefined")
      .map((image) =>
        this.readerService.getAuthenticatedImageUrl(image).pipe(
          map((url) => {
            this.objectUrls.push(url);
            return { small: url, medium: url, big: url };
          }),
          catchError(() => of(null))
        )
      );

    if (requests.length === 0) {
      this.galleryImages = [];
      return;
    }

    forkJoin(requests).subscribe({
      next: (imagesURL: Array<NgxGalleryImage | null>) => {
        this.galleryImages = imagesURL.filter(
          (image): image is NgxGalleryImage => image != null
        );
      },
      error: () => {
        this.galleryImages = [];
      },
    });
  }

  ngOnDestroy(): void {
    this.objectUrls.forEach((url) => {
      if (typeof URL !== "undefined" && typeof URL.revokeObjectURL === "function") {
        URL.revokeObjectURL(url);
      }
    });
  }
}
